module.exports = __webpack_public_path__ + "static/media/redcoin.0ffc11ca.svg";